
<template>
  <div class=" field ">
    <p>Melde dich hier an. Deine Natelnummer benötigen wir für kurzfristige Änderungen.</p>
    <input
      type="text"
      v-model="displayName"
      placeholder="Name"
      required
    ><br>
    <input
      type="text"
      v-model="email"
      placeholder="Email"
      required
    ><br>
    <input
      type="text"
      v-model="telNumber"
      placeholder="Natelnummer"
      required
    ><br>
    <!-- <input type="text" placeholder="T-Shirt Grösse"><br> -->
    <p>Shirt</p>
    <select
      class="select"
      v-model="shirtsize"
      required
    >
      <!-- <option value="xs">XS</option> -->
      <option value="s">S</option>
      <option value="m">M</option>
      <option value="l">L</option>
      <option value="xl">XL</option>
      <option value="xxl">XXL</option>

    </select><br>
    <input
      type="password"
      v-model="password"
      placeholder="Passwort"
    ><br>
    <input
      type="password"
      v-model="passwordControll"
      placeholder="Passwort erneut eingeben"
    ><br>
    <input
      style="display:none"
      type="text"
      v-model="spamControll"
      placeholder=""
    >
    <button v-on:click="signUp">Benutzer erstellen</button>
    <span>Du hast bereits einen Account?
      <router-link to="/login">login</router-link>.</span>
  </div>
</template>

<script>
/* eslint-disable */
import firebase from "firebase";

require("firebase/firestore");

export default {
  name: "signUp",
  data: function () {
    return {
      displayName: "",
      telNumber: "",
      shirtsize: "",
      email: "",
      password: "",
      passwordControll: "",
      spamControll: "",
    };
  },
  methods: {
    signUp: function () {
      if (!this.telNumber) {
        alert("Telefonnummer eingeben")
        return
      }
      if (!this.displayName) {
        alert("Name eingeben")
        return
      }
      if (!this.shirtsize) {
        alert("Shirtgrösse auswählen")
        return
      }
      if (this.password !== this.passwordControll) {
        alert("Deine Passwörter sind nicht identisch")
        return
      }
      if (this.spamControll) {
        console.log("nope")
        return

      }
      if (this.displayName && this.telNumber && this.shirtsize && !this.spamControll && this.password === this.passwordControll) {

        blur()
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(
            user => {

              firebase
                .firestore()
                .doc("users/" + user.user.uid)
                .set({
                  displayName: this.displayName,
                  email: this.email,
                  telNumber: this.telNumber,
                  shirtsize: this.shirtsize,
                  // avatar: user.photoURL,
                  userID: user.user.uid,
                  admin: false
                })
                .then(() => {


                  console.log("User added to Firestore!");
                  this.$router.replace("hello");
                })
                .catch(err => {
                  console.log(err);
                });
            },
            err => {
              alert("Oops. " + err.message);
            }
          );
      }
      else return
    }
  }
};
</script>

<style scoped>
.signUp {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  /* width: 20%; */
  padding: 15px;
}
button {
  margin-top: 10px;
  /* width: 10%; */
  cursor: pointer;
}
span {
  display: block;
  margin-top: 20px;
  font-size: 11px;
}
</style>
